import { required } from 'vuelidate/lib/validators';

export default {
  payload: {
    leaseId: {
      required
    },
    amountTotal: {
      required
    },
    claimType: {
      required
    }
  },
  files: {
    required
  }
};
